module.exports = __webpack_public_path__ + "img/20.45dc78fe.png";